import { actionSet } from './utils'
import { getPages } from 'component/pagination/utils'
import { hideSpinner, showSpinner } from './spinner'
import {
  FETCH_PRICEBANNER_PARAMS_SUCCESS,
  FETCH_PRICEBANNER_PARAMS_ERROR,
  SAVE_PRICEBANNER_PARAMS_SUCCESS,
  SAVE_PRICEBANNER_PARAMS_ERROR,
  DELETE_PRICEBANNER_PARAMS_SUCCESS,
  DELETE_PRICEBANNER_PARAMS_ERROR,
  UPDATE_PRICEBANNER_PARAMS_SUCCESS,
  UPDATE_PRICEBANNER_PARAMS_ERROR
} from 'constants/actionTypes'
import API_URL from 'constants/api'
import Api from 'utils/ApiRequest'

export const fetchAll = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    const queryParams = new URLSearchParams()
    Object.entries(param || {}).forEach(([key, value]) => {
      if (value === null || value === undefined) return
      if (Array.isArray(value)) {
        value.forEach(item => {
          if (item !== null && item !== undefined) {
            queryParams.append(key, item)
          }
        })
        return
      }
      queryParams.append(key, value)
    })

    const api = `${API_URL.FETCH_PRICEBANNER_PARAMS}?${queryParams.toString()}`

    const response = await new Api(token, dispatch).get(api);

    const { data, metadata } = response

    dispatch(getPages(data.pages)) 

    return dispatch(
      actionSet(FETCH_PRICEBANNER_PARAMS_SUCCESS, { data, metadata })
    )

  } catch (error) {
    return dispatch(actionSet(FETCH_PRICEBANNER_PARAMS_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}

export const saveParams = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    const response = await new Api(token, dispatch).post(
      API_URL.SAVE_PRICEBANNER_PARAMS,
      param
    )

    if (response.cdStatus === 409) {
      dispatch(actionSet(SAVE_PRICEBANNER_PARAMS_ERROR, response))
      throw response
    }

    const { data } = response

    dispatch(actionSet(SAVE_PRICEBANNER_PARAMS_SUCCESS, data))
    const invalidStores = Array.isArray(data) ? data : []
    return { data, invalidStores }
  } catch (error) {
    dispatch(actionSet(SAVE_PRICEBANNER_PARAMS_ERROR, error))
    const invalidStores = Array.isArray(error?.data) ? error.data : []
    if (invalidStores.length > 0 && error.cdStatus !== 409) {
      return { data: error.data, invalidStores, error }
    }
    throw error 
  } finally {
    dispatch(hideSpinner())
  }
}

export const updateParams = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    const response = await new Api(token, dispatch).put(
      API_URL.UPDATE_PRICEBANNER_PARAMS,
      param
    )

    if (response.cdStatus === 409) {
      dispatch(actionSet(UPDATE_PRICEBANNER_PARAMS_ERROR, response))
      throw response
    }

    const { data } = response

    dispatch(actionSet(UPDATE_PRICEBANNER_PARAMS_SUCCESS, data))
    const invalidStores = Array.isArray(data) ? data : []
    return { data, invalidStores }
  } catch (error) {
    dispatch(actionSet(UPDATE_PRICEBANNER_PARAMS_ERROR, error))
    const invalidStores = Array.isArray(error?.data) ? error.data : []
    if (invalidStores.length > 0 && error.cdStatus !== 409) {
      return { data: error.data, invalidStores, error }
    }
    throw error 
  } finally {
    dispatch(hideSpinner())
  }
}

export const deleteParams = (token, cdPricebannerParamsList) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    await new Api(token, dispatch).post(API_URL.DELETE_PRICEBANNER_PARAMS, cdPricebannerParamsList);

    dispatch(actionSet(DELETE_PRICEBANNER_PARAMS_SUCCESS))
    return true;

  } catch (error) {
    dispatch(actionSet(DELETE_PRICEBANNER_PARAMS_ERROR, error))
    return false;
  } finally {
    dispatch(hideSpinner())
  }
}
